import { createAction } from '@reduxjs/toolkit';
import type { ResolvedResponse, Status } from '@innovyze/lib-am-common';

import { addNamespace } from '@Utils/actions';
import {
  GetCostTableGridPaginatedRequest,
  CostTableListGridState,
} from '@Types/costTable.types';

interface CostTableOverviewResolvedResponse extends ResolvedResponse {
  totalCount: number;
}

export const listCostTablesAction =
  createAction<GetCostTableGridPaginatedRequest>(
    addNamespace('costTablesOverview/list')
  );

export const listCostTableActionResolved =
  createAction<CostTableOverviewResolvedResponse>(
    addNamespace('costTablesOverview/listResolved')
  );

export const listCostTablesActionRejected = createAction<Status>(
  addNamespace('costTablesOverview/listRejected')
);

export const getCostTableDetailsAction = createAction<{ costTableId: string }>(
  addNamespace('costTableDetails/get')
);

export const getCostTableDetailsActionResolved = createAction<ResolvedResponse>(
  addNamespace('costTableDetails/getResolved')
);

export const getCostTableDetailsActionRejected = createAction<Status>(
  addNamespace('costTableDetails/getRejected')
);

export const invalidateCostTablesOverview = createAction(
  addNamespace('costTablesOverview/invalidate')
);

export const saveCostTableListGridState = createAction<CostTableListGridState>(
  addNamespace('costTablesOverview/saveGridState')
);
